
$soupmail.control.editable = function($config) {
	
	this.config = {
		selector : '#editable',
		model : '',
		listArrayKey : '',
		itemId : 1,
		column : { name:'id', label:'ID', cssclass:'id', layoutView:'', layoutEdit:'', maxlength:255 },
		editingEnabled : true,
		onChange : '',
		dataWrapperElem : '',
		dataRowElem : 'div',
		dataItemRowId : '',
		dataItemRowClass : '',
		dataItemElem : 'div',
		validation : {validator: 'required', failMessage: 'Please ensure this field is filled in.'}
	};
	
	this.item = {};
	this.destroy = destroy;
	this.reset = reset;
	this.load = load;
	this.change = change;
	this.render = render;
	this.renderItemRow = renderItemRow;
	this.val = val;
	this.remove = remove;
	this.show = show;
	this.hide = hide;
	this.toggle = toggle;
	this.enableValidation = enableValidation;
	this.disableValidation = disableValidation;
	this.validOrError = validOrError;
		
	if ($config) {
		var editable = this;
		jQuery.each($config, function($key, $val) {
			editable.config[$key] = $val;
		});
	}
	
	function destroy() {
		if (this.validator) {
			this.validator.destroy();
		}
	};
	
	function reset() {
		this.item = {};
	};
	
	function load($callback) {
		var editable = this;
		$models[this.config.model].getItem(this.config.itemId, function($data) {
			if (editable.config.listArrayKey) {
				editable.item = $data[editable.config.listArrayKey];
			} else {
				editable.item = $data;
			}
			editable.item._visible = true;
			editable.render();
			editable.change();
			if (typeof($callback) == 'function') {
				$callback();
			}
		});
	};
	
	function change($func) {
		if (typeof($func) == 'function') {
			this.config.onChange = $func;
		} else if (typeof(this.config.onChange) == 'function') {
			this.config.onChange();
		}
	};
	
	function render() {
		var html = '';
		if (this.config.dataWrapperElem) {
			html += '<'+this.config.dataWrapperElem+'>' + "\r\n";
		}
		if (this.item._visible && !this.config.column.hidden && this.config.column.label) {
			html += '<'+this.config.dataRowElem+' class="editable-label">'+this.config.column.label+'</'+this.config.dataRowElem+'>';
		}
		if (this.item._visible && !this.config.column.hidden) {
			html += '<'+this.config.dataRowElem+(this.config.dataItemRowId ? ' id="'+this.config.dataItemRowId.replace('{id}', this.item.id)+'"' : '')+' class="'+(this.config.dataItemRowClass ? this.config.dataItemRowClass + ' ' : '')+(this.config.editingEnabled ? 'editable-field ' : 'non-editable-field ')+'row-'+this.item.id+'" data-id="'+this.item.id+'"></'+this.config.dataRowElem+'>';
		}
		if (this.config.dataWrapperElem) {
			html += '</'+this.config.dataWrapperElem+'>' + "\r\n";
		}
		jQuery(this.config.selector).html(html);
		if (this.item._visible) {
			this.renderItemRow(this.item);
		}
		if (this.item._visible && this.config.editingEnabled) {
			var editable = this;
			jQuery(this.config.selector + ' *').unbind('click');
			jQuery(this.config.selector).find('a.edit-button').click(function() {
				jQuery(editable.config.selector).find('.value, .editbutton').hide();
				jQuery(editable.config.selector).find('.editable, .savebutton, .cancelbutton').show();
				editable.enableValidation();
				if (editable.config.validation) {
					editable.validator.validate();
				}
			});
			jQuery(this.config.selector).find('a.cancel').click(function() {
				jQuery(editable.config.selector).find('.value, .editbutton').show();
				jQuery(editable.config.selector).find('.editable, .savebutton, .cancelbutton').hide();
				editable.disableValidation();
			});
		}
	};
	
	function renderItemRow($item) {
		var row = '';
		var cssClass = (this.config.column.cssclass ? ' '+this.config.column.cssclass : '');
		if (!this.config.column.hidden) {
			var data = (this.config.column.layoutView ? this.config.column.layoutView : '{'+this.config.column.name.replace('.', '_')+'}').replace(/{/gi, '<span class="data_').replace(/}/gi, '"></span>');
			row += '<'+this.config.dataItemElem+' class="value'+cssClass+'">'+data+'</'+this.config.dataItemElem+'>';
		}
		if (!this.config.column.hidden && this.config.editingEnabled) {
			var name = this.config.listArrayKey + '_' + this.config.column.name.replace('.', '_');
			var data = (this.config.column.layoutEdit ? this.config.column.layoutEdit : '<input type="text" class="text" name="'+name+'" id="'+name+'" maxlength="'+this.config.column.maxlength+'" value="" />');
			row += '<'+this.config.dataItemElem+' class="editable'+cssClass+'" style="display:none">'+data+'</'+this.config.dataItemElem+'>';
			row += '<'+this.config.dataItemElem+' class="editbutton'+cssClass+'"><a class="edit-button" onclick="return false" rel="tipsy" href="#" original-title="Edit"></a></'+this.config.dataItemElem+'>';
			row += '<'+this.config.dataItemElem+' class="savebutton'+cssClass+'" style="display:none"><input type="button" value="Save"></'+this.config.dataItemElem+'>';
			row += '<'+this.config.dataItemElem+' class="cancelbutton'+cssClass+'" style="display:none"><a class="cancel" onclick="return false" href="#">Cancel</a></'+this.config.dataItemElem+'>';
		}
		jQuery(this.config.selector).find('.row-'+$item.id).html(row);
		if (!this.config.column.defaultvalue) {
			this.config.column.defaultvalue = '---';
		}
		var name = this.config.column.name;
		if (name) {
			var value = ($item[name] ? $item[name] : this.config.column.defaultvalue);
			if (name.indexOf('.') > 0) {
				var nameParts = name.split('.');
				var namePartsParent = nameParts[0];
				var namePartsChild = nameParts[1];
				value = ($item[namePartsParent] ? $item[namePartsParent][namePartsChild] : this.config.column.defaultvalue);
			}
			if (typeof(this.config.column.onBeforeRender) == 'function') {
				value = this.config.column.onBeforeRender(value, $item);
			}
			jQuery(this.config.selector).find('.row-'+$item.id+' span.data_'+name.replace('.', '_')).text(value);
			jQuery(this.config.selector).find('.row-'+$item.id+' .editable').children('input, select, textarea').val(value);
		}
		if (typeof(this.config.column.onAfterRender) == 'function') {
			this.config.column.onAfterRender($item, jQuery(this.config.selector).find('.row-'+$item.id));
		}
		return row;
	};
	
	function val($value) {
		if (!$value) {
			return jQuery(editable.config.selector).find('.editable input, .editable select, .editable textarea').val();
		}
		if (!this.item) {
			this.item = {};
		}
		var name = this.config.column.name;
		this.item[name] = $value;
		this.render();
		this.change();
	};
	
	function remove() {
		this.reset();
		jQuery(this.config.selector).find('.row-'+$id).fadeOut('slow');
	};
	
	function show($visibility) {
		if (typeof($visibility) != 'boolean') {
			$visibility = true;
		}
		this.item._visible = $visibility;
		this.render();
		this.change();
	};
	
	function hide() {
		this.show(false);
	};
	
	function toggle() {
		this.show(!this.item._visible);
	};
	
	function enableValidation() {
		if (this.config.validation) {
			this.config.validation.selector = (this.config.selector + ' .editable input');
			this.validator = new $soupmail.validator(this.config.validation);
		}
	};
	
	function disableValidation() {
		if (this.config.validation) {
			this.validator.destroy();
		}
	};
	
	function validOrError(message) {
		if (this.validator) {
			return this.validator.validOrError(message);
		} else {
			return true;
		}
	};
	
};



// WEBPACK FOOTER //
// ./src/js/helpers/soupmail.control.editable.js